// extracted by mini-css-extract-plugin
export default {"attach":"Attach_attach__zCSR+","icon":"Attach_icon__urMaM","body":"Attach_body__hBdUJ","title":"Attach_title__rpPV2","info":"Attach_info__pEmeQ","download":"Attach_download__HUoTM"};